import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { PromocionesService } from '../../services/promociones.service';
import { ApiResponse } from 'src/app/model/interfaces/response';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { downloadBase64File } from 'src/utils/utils';

@Component({
  selector: 'app-promo-accordion',
  templateUrl: './promo-accordion.component.html',
  styleUrls: ['./promo-accordion.component.css']
})
export class PromoAccordionComponent {

  @Input()
  promos: string[] = [];

  @Input()
  selectedPromos: string[] = [];

  @ViewChild('fileClientInput')
  fileClientInput: ElementRef;

  rangeForm!: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly toastrService: ToastrService,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.buildForm();
  }

  private buildForm() {
    this.rangeForm = this.formBuilder.group({
      start: ['', [Validators.required]],
      end: ['', [Validators.required]]
    })
  }

  downloadCsv() {
    this.promocionesService.downloadCsv().subscribe((res) => downloadBase64File(res, 'promociones.csv'))
  }

  downloadCsvActives() {
    this.promocionesService.downloadCsv(true).subscribe((res) => downloadBase64File(res, 'promociones.csv'))
  }

  downloadCsvRange() {
    const start = this.rangeForm.get('start').value;
    const end = this.rangeForm.get('end').value;
    this.promocionesService.downloadCsv(false, start, end).subscribe((res) => downloadBase64File(res, 'promociones.csv'))
  }

  downloadCsvFromList() {
    this.promocionesService.downloadCsvFromList(this.selectedPromos).subscribe((res) => downloadBase64File(res, 'promociones.csv'))
  }

  onFileClient(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.toastrService.error('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV"');
        this.fileClientInput.nativeElement.value = '';
      } else {
        this.uploadCsv(file);
      }
    }
  }

  private uploadCsv(file) {
    const formData = new FormData();
    formData.append('file', new Blob([file], { type: 'text/csv' }), 'file');
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro de enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this.promocionesService.uploadCsvClient(formData)
      })
        .then((res: ApiResponse<string>) => {
          this.toastrService.success(res.mensaje, `${res.key}`);
        })
        .finally(() => {
          if (this.fileClientInput) this.fileClientInput.nativeElement.value = '';
        });
  }

}
